export default "__VITE_ASSET__Cy1v1aqG__"